import React, { useState } from "react";
import { Formik, Form, yupToFormErrors } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import { createMember } from "../../redux/actions/api/apiAction";
import moment from "moment";
import { store } from "../../redux/storeConfig/store";
import { NoteMemberDetails } from "../../views/pages/gymPortion/members/noteMemberDetails";
import { useSelector } from "react-redux";
import SpinnerComponent from "../spinner/spinner";
import DeletedMemberModal from "../../views/pages/gymPortion/members/deletedMemberDetailsModal";
import { memberFieldErrors } from "./memberFields";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";
import { isValidPhoneInput } from "../../utils/phone";

const regEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// export const MultiStep = () => {
function MultiStepForMember({
  name,
  firstName,
  lastName,
  middleName,
  martialStatus,
  homeAddress,
  street,
  occupation,
  companyName,
  emergencyName,
  emergencyPhone,
  email,
  phone,
  gender,
  activeStatus,
  handleSubmit,
  handleSubmitForUpdate,
  edit,
  dob,
  image,
  id,
  packages,
  verifiyedUsing,
  RFIDCardIdField,
  cardMembershipId,
  verifyBy,
  metaData,
  childerNote,
}) {
  const { features, gymFeaturesObject } = useSelector(
    (state) => state.features
  );
  const { loading, gym, gymConfig } = useSelector((state) => state.gym);
  const { settings } = useSelector((state) => state.gym.gym);

  const [step, setStep] = useState(1);
  const [numberOfRelations, setNumberOfRelations] = useState(0);
  const [relations, setRelations] = React.useState([]);
  const [additionalInfoErrors, setAdditionalInfoErrors] = useState({});

  const validateAdditionalInfo = (values) => {
    const errorMessages = memberFieldErrors(values, settings, gymConfig);
    const canSubmit = Object.keys(errorMessages).length === 0;
    setAdditionalInfoErrors(canSubmit ? {} : errorMessages);
    return canSubmit;
  };
  
  handleSubmit = async (values, { setErrors, errors }) => {
    const scannedCard =
      values.RFIDCardIdField ||
      values.cardMembershipId ||
      (store.getState().membershipCard &&
        store.getState().membershipCard.RFIDCardId);
    if (scannedCard) {
      values.RFIDCardIdField = scannedCard;
      values.cardMembershipId = scannedCard;
    }
    const rfidRequired =
      gymConfig?.gates?.enabled && gymConfig?.gates?.accessBy == "RFIDCards";
    if (rfidRequired) {
      values.requireCard = true;
      if (!values.RFIDCardIdField) {
        return;
      }
      values.cardMembershipId = values.RFIDCardIdField;
    }

    if (!validateAdditionalInfo(values)) {
      setErrors(memberFieldErrors(values, settings, gymConfig));
      return;
    }

    if (saveVoiceDraftEdit(values)) {
      return;
    }

    await store.dispatch(
      createMember({
        ...values,
        verifyBy: !settings?.memberRegistration?.fields?.verificationBy?.enabled ? false : values.verifyBy,
        smsGateway: gym?.smsGateway,
        superGymAdmin: gym?.superGymAdmin,
      })
    );
  };

  const submit = (values, { setErrors }) => {
    if (edit) {
      handleSubmitForUpdate(values);
    } else {
      handleSubmit(values, { setErrors });
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = Yup.object().shape({
    image: Yup.string(),
    firstName: Yup.string().required("First Name is required"),
    phone: Yup.string()
      .nullable()
      .test(
        "phone-valid",
        "Phone number is not valid",
        function (value) {
          return isValidPhoneInput(value, this.parent.country);
        }
      ),
    // .required("Please enter valid phone number"),
    email: Yup.string().email("Please enter valid Username i.e email"),
    // .required("Email is required"),
    dob: Yup.date(),
    gender: Yup.string().required("Gender is required"),
    relationOpen: Yup.boolean(),
    relations: Yup.array()
      .of(
        Yup.object().shape({
          firstName: Yup.string().required(
            "Family member first name is required"
          ),

          gender: Yup.string().required("Family member gender is required"),

          relation: Yup.string().required("Family relation is required"),
          dob: Yup.string().required("Date of birth is required"),
          accountType: Yup.string(),
        })
      )
      .min(
        numberOfRelations,
        "Please fill all relation fields or close the relation section "
      ),

    // activeStatus: Yup.string().required('Status is required'),
  });

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("member", {
          name,
          firstName,
          middleName,
          martialStatus,
          homeAddress,
          street,
          occupation,
          companyName,
          emergencyName,
          emergencyPhone,
          lastName,
          email,
          phone,
          gender,
          activeStatus,
          image,
          dob,
          relations: [],
          accountType: "primary",
          id,
          verifiyedUsing,
          cardMembershipId: cardMembershipId || "",
          RFIDCardIdField,
          verifyBy,
          healthProblem: metaData?.healthProblem || "",
          medicalHistory: metaData?.medicalHistoryData || {},
          handedness: metaData?.handedness || [],
          smokingHabits: metaData?.smokingHabits || [],
          referralSource: metaData?.referralSource || "",
          insuranceDetails: metaData?.insuranceDetails || {},
          referralNote:metaData?.referralSource?.referralNote||"",
          childerNote: childerNote || "",
        })}
        onSubmit={(values, { setErrors }) => {
          submit(values, { setErrors });
        }}
        validate={(values) => {
          if (
            values.phone &&
            !isValidPhoneInput(values.phone, values.country)
          ) {
            return { phone: "Phone number is not valid" };
          }
          return {};
        }}
        validationSchema={formSchema1}
      >
        {({
          errors,
          touched,
          values,
          setFieldValue,
          setErrors,
          handleBlur,
          setFieldTouched,
        }) => (
          <Form>
            <FormFirstStep
              relations={relations}
              setRelations={setRelations}
              setErrors={setErrors}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldTouched={setFieldTouched}
              values={values}
              setFieldValue={setFieldValue}
              setNumberOfRelations={setNumberOfRelations}
              numberOfRelations={numberOfRelations}
              packages={packages}
              additionalInfoErrors={additionalInfoErrors}
              validateAdditionalInfo={validateAdditionalInfo}
            />

            <StepButton
              step={step}
              previous={previous}
              edit={edit}
              disableSubmit={Boolean(
                values.phone &&
                  !isValidPhoneInput(values.phone, values.country)
              )}
            />
          </Form>
        )}
      </Formik>
      <NoteMemberDetails />
      <DeletedMemberModal/>
    </>
  );
}
MultiStepForMember.defaultProps = {
  name: "",
  firstName: "",
  middleName: "",
  martialStatus: "",
  homeAddress: "",
  street: "",
  occupation: "",
  companyName: "",
  emergencyName: "",
  lastName: "",
  emergencyPhone: "",
  email: "",
  phone: "",
  dob: "",
  id: "",
  handleSubmit: (values) => {
  },
  edit: false,
  type: "",
  image: "",
  gender: "",
  relations: [],
  accountType: "primary",
  cardMembershipId: "",
  RFIDCardIdField: "",
  verifyBy: "phone",
  metaData: {},
  // handleSubmitForUpdate: (values) => {
  //   //console.log(values, 'values here');
  // },
};

export default MultiStepForMember;
